import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-refetch'
import { Button, Card, CardActions, CardTitle } from 'react-mdl'
import * as actions from '../actions/index'
import * as styles from '../styles/styles'
import { fixTrailingSlashInPath, connectDefault, checkNextPropsPromiseFulfilled } from '../utils/utils'

var introJs = require("intro.js").introJs();
var willShowIntro = false

export class Apps extends Component {
  static propTypes = {
    location: PropTypes.object.isRequired,
    accountBaseURL: PropTypes.string.isRequired,
    ahBaseUrl: PropTypes.string.isRequired,
    appId: PropTypes.string,
    channelType: PropTypes.string,
    dispatch: PropTypes.func.isRequired,
  }

  static contextTypes = {
    router: PropTypes.object.isRequired,
  }

  constructor(props,context) {
    super(props,context);

    this.addApp = this.addApp.bind(this);
  }

  componentWillMount() {
    this.refresh(this.props)
  }

  componentWillReceiveProps(nextProps) {
    //retorning from the AppPage
    if (this.props.appId !== undefined && nextProps.appId === undefined) {
      this.refresh(nextProps)
    }
    else if (checkNextPropsPromiseFulfilled(this.props, nextProps, 'apps')) {
      const apps = nextProps.apps.value
      const appsTitles = {}
      for (var x = 0 ; x<apps.length ; x++) {
        const app = apps[x]
        appsTitles[app.id] = app.title
      }

      this.props.dispatch(actions.addBreadcrumbsRouteTitles({'app':appsTitles}))

      if (!sessionStorage.getItem('introjs_Apps')) {
        willShowIntro = true
        sessionStorage.setItem('introjs_Apps', true)
      }
    }
  }

  componentDidUpdate() {
    if (willShowIntro && !this.props.children) {
      introJs.setOptions({ 'showStepNumbers': false, 'showBullets': false });
      introJs.start()

      willShowIntro = false
    }
  }

  refresh(props) {
    props.fetchApps()
    if (!props.children) {
      props.dispatch(
          actions.setTopbarButtons([
              { key:"APP_ADD", title:"Create", icon: "add", action:this.addApp }
          ])
      )
    }
  }

  addApp() {
    // Make unique titles
    const apps = this.props.apps.fulfilled ? this.props.apps.value : [];
    const len = apps.length + 1;
    let t;
    switch(len) {
      case 1: t = "New"; break;
      case 2: t = "Second"; break;
      case 3: t = "Third"; break;
      default: t = len + 'th';
    }
    this.props.postApp({ title: t + " Brand" })
  }

  viewApp(app) {
    introJs.exit()
    const currentPath = fixTrailingSlashInPath(this.props.location.pathname);
    this.context.router.push(`${currentPath}${app.id}`);
  }

  showIntrojsForApp(app) {
    var date = new Date(app.created)
    const MINUTE = 1000 * 60;
    let anHourAgo = Date.now() - MINUTE;
    return date > anHourAgo;
  }

  render() {
    const { dispatch, appId, ahBaseUrl, accountBaseURL, channelType } = this.props


    if (this.props.children) {
      let children = null;
      children = React.cloneElement(this.props.children, {
                                    ahBaseUrl: ahBaseUrl,
                                    appBaseURL: `${accountBaseURL}/apps/${appId}`,
                                    channelType: channelType,
                                    dispatch: dispatch
                                    })
      return children
    }

    const apps = (this.props.apps !== undefined && this.props.apps.fulfilled) ? this.props.apps.value : []

    return (
      <div>
        {
          apps.map( (app, index) => (
            <div onClick={()=>{this.viewApp(app)}} key={index} style={styles.apps.cardDiv}>
              <Card shadow={0} style={styles.apps.card}>
                <CardTitle expand style={styles.apps.cardTitle}>
                  <h4 style={{marginTop: '0', fontSize: '22px'}}>
                    {app.title}
                  </h4>
                </CardTitle>
                <CardActions border>
                <Button colored {...(index===0 && this.showIntrojsForApp(app)) ? {'data-intro':'Click here to complete the setup'} : {}}>Manage</Button>
                </CardActions>
              </Card>
            </div>
            )
          )
        }
      </div>

    )
  }
}

export default connect.defaults(connectDefault)(props => {
  return {
    fetchApps: () => ({
      apps: {
        title: 'Fetch Apps',
        dispatch: props.dispatch,
        url:`${props.accountBaseURL}/apps`,
        refreshing: true, force: true
      }
    }),
    postApp: app => ({
      postAppResponse: {
        title: 'Create App',
        dispatch: props.dispatch,
        url: `${props.accountBaseURL}/apps`,
        refreshing: true, force: true,
        method: 'POST',
        body: app,
        andThen: () => ({
          apps: {
            title: 'Fetch Apps',
            dispatch: props.dispatch,
            url:`${props.accountBaseURL}/apps`,
            refreshing: true, force: true
          }
        })
      }
    })
  }
})(Apps)



// WEBPACK FOOTER //
// ./src/containers/Apps.js